module.exports = __webpack_public_path__ + "static/revat-team_2_mobile-6cf84dc2f69030828d146bc01d6cc3e8.jpg";